import Mock from 'mockjs'

const Random = Mock.Random

// // 素材网站列表
// const siteList = [
//   '觅知网', '90设计', '众图网', '红动中国', '潮点视频',
//   '包图网', '熊猫办公', '千图网', '享设计', '酷图网',
//   '摄图网', '我图网', '花瓣网', '站酷海洛', '图怪兽'
// ]

// // 网站对应的链接前缀
// const siteLinkMap = {
//   '觅知网': 'https://www.51miz.com/muban/',
//   '90设计': 'https://90sheji.com/sucai/',
//   '众图网': 'https://www.ztupic.com/sucai/',
//   '红动中国': 'https://sucai.redocn.com/',
//   '潮点视频': 'https://www.chaodian.com/video/',
//   '包图网': 'https://ibaotu.com/sucai/',
//   '熊猫办公': 'https://www.tukuppt.com/muban/',
//   '千图网': 'https://www.58pic.com/tupian/',
//   '享设计': 'https://www.design006.com/detail-',
//   '酷图网': 'https://www.ikutu.com/detail/',
//   '摄图网': 'https://699pic.com/tupian/',
//   '我图网': 'https://www.ooopic.com/sucai/',
//   '花瓣网': 'https://huaban.com/pins/',
//   '站酷海洛': 'https://www.hellorf.com/image/',
//   '图怪兽': 'https://818ps.com/sucai/'
// }

// 生成套餐数据
// export function generatePackages() {
//   const packages = []
//   const usedSites = []

//   const count = Random.integer(8, 14)
//   for (let i = 0; i < count; i++) {
//     let site
//     do {
//       site = siteList[Random.integer(0, siteList.length - 1)]
//     } while (usedSites.includes(site))
//     usedSites.push(site)

//     const total = Random.pick([20, 30, 50, 100])
//     const remaining = Random.integer(0, total)

//     // 随机有效期，大部分很远，少数快过期
//     let expiry
//     if (Random.integer(1, 10) <= 2) {
//       // 20% 概率快过期
//       const d = new Date()
//       d.setDate(d.getDate() + Random.integer(1, 30))
//       expiry = formatDate(d)
//     } else {
//       const year = Random.integer(2028, 2299)
//       const month = String(Random.integer(1, 12)).padStart(2, '0')
//       const day = String(Random.integer(1, 28)).padStart(2, '0')
//       const hour = String(Random.integer(0, 23)).padStart(2, '0')
//       const min = String(Random.integer(0, 59)).padStart(2, '0')
//       expiry = `${year}-${month}-${day} ${hour}:${min}`
//     }

//     packages.push({
//       id: i + 1,
//       name: site,
//       expiry,
//       remaining,
//       total
//     })
//   }
//   return packages
// }

// // 生成下载记录数据
// export function generateDownloadRecords(count = 147) {
//   const records = []
//   const now = new Date()

//   for (let i = 0; i < count; i++) {
//     const site = siteList[Random.integer(0, siteList.length - 1)]
//     const prefix = siteLinkMap[site] || 'https://example.com/'
//     const suffix = Random.integer(10000000, 99999999)

//     // 时间从现在往前推，越往后越早
//     const offsetMs = i * Random.integer(1800000, 7200000) // 每条间隔0.5~2小时
//     const date = new Date(now.getTime() - offsetMs)

//     records.push({
//       id: i + 1,
//       time: formatDate(date),
//       site,
//       link: `${prefix}${suffix}.html`
//     })
//   }

//   return records
// }

// 生成用户数据
export function generateUserInfo(username) {
  return {
    username: username || 'admin',
    nickname: username || 'admin',
    email: `${username || 'admin'}@example.com`,
    phone: `1${Random.string('3456789', 1)}${Random.string('number', 1)}****${Random.string('number', 4)}`,
    avatar: ''
  }
}

// 公告数据
export function generateNotice() {
  const notices = [
    '系统已全面升级，新增摄图网、站酷海洛等优质素材源，欢迎使用！',
    '即日起购买年度套餐享8折优惠，详情请联系客服。',
    '温馨提示：每日下载次数有限，请合理安排下载计划。',
    '新用户注册即送5次免费下载体验，快来试试吧！',
    '系统维护通知：每周日凌晨2:00-4:00进行例行维护，届时服务暂停。'
  ]
  return notices[Random.integer(0, notices.length - 1)]
}

function formatDate(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const h = String(date.getHours()).padStart(2, '0')
  const min = String(date.getMinutes()).padStart(2, '0')
  return `${y}-${m}-${d} ${h}:${min}`
}
